import WrapperProvider from "@providers/WrapperProvider";
import ContactContainer from "@containers/ContactContainer";
import LocomotiveProvider from "@providers/LocomotiveProvider";
import Layout from "@components/Layout";
import { getServer } from "@translations/next";
import _ from "lodash";
import StrapiService from "@services/StrapiService";
import FooterService from "@services/FooterService";
export default function Home(props: any) {
  return (
    <WrapperProvider pageContext={props}>
      <Layout>
        <LocomotiveProvider
          options={{
            smooth: true,
            getSpeed: true,
            getDirection: true,
            reloadOnContextChange: true,
            mobile: {
              smooth: true,
            },
            tablet: {
              smooth: true,
            },
          }}
        >
          <ContactContainer />
        </LocomotiveProvider>
      </Layout>
    </WrapperProvider>
  );
}
export const getServerSideProps = getServer(async ({ params }) => {
  const locale: any = _.get(params, "locale", "en");
  StrapiService.set("id", "group-contact-page");
  const res = await StrapiService.find({ populate: "deep", locale });
  const footerData = await FooterService.fetchByHotel(undefined, locale);
  return {
    pageData: _.get(res, "data", {}),
    footerData,
  };
});
